import React, {useEffect, useState} from "react";
import Header from "../components/Header";
import {FIREBASE_SCREEN_NAMES, HEADER_SIZE, LOCALSTORAGE_ITEMS, ORDER_PLACE, USER_TYPES} from "../util/Constants";
import * as StorageService from "../services/StorageService";
import {FormattedMessage, FormattedNumber, IntlProvider} from "react-intl";
import QuantityModifier from "../components/QuantityModifier.js";
import noPhotoImg from "../assets/img/no-photo.png";
import loyaltyRibbon from "../assets/img/loyalty_ribbon.svg";
import Spinner from "../components/Spinner";
import {
    getAppLocale,
    getExtraProductName,
    getProdDesc,
    getProdName,
    getProdOptions,
    isShopOpen,
    roundHalfEven
} from "../util/common";
import {EventBus} from "../util/EventBus";
import {PATH} from "../routes/routes";
import analyticsLogEvent from "../services/FirebaseService";
import * as ProductService from "../services/ProductService";
import celery from "../assets/img/allergens/Celery.svg";
import cereals from "../assets/img/allergens/Cereals.svg";
import crustaceans from "../assets/img/allergens/Crustaceans.svg";
import eggs from "../assets/img/allergens/Eggs.svg";
import fish from "../assets/img/allergens/Fish.svg";
import lupin from "../assets/img/allergens/Lupin.svg";
import milk from "../assets/img/allergens/Milk.svg";
import molluscs from "../assets/img/allergens/Molluscus.svg";
import mustard from "../assets/img/allergens/Mustard.svg";
import peanuts from "../assets/img/allergens/Peanuts.svg";
import nuts from "../assets/img/allergens/Walnuts.svg";
import sesame from "../assets/img/allergens/Sesame.svg";
import soybeans from "../assets/img/allergens/Soybeans.svg";
import sulphurdioxide from "../assets/img/allergens/Sulphurdioxide.svg";
import * as UserService from "../services/UserService";
import LoginOrContinueAsGuest from "./Authentication/LoginOrContinueAsGuest";
import ScanQrToContinue from "../components/ScanQrToContinue";
import {useLocation, useNavigate} from "react-router";
import ProductDetailsActionsBar from "../components/Actionsbar/ProductDetailsActionsBar";


function ProductDetails() {
    const navigateTo = useNavigate();
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const readonly = query.get('readonly');
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const hasMultiOrders = shopDetails ? (typeof shopDetails.merchantConfig.multiOrders !== "undefined" ? shopDetails.merchantConfig.multiOrders : null) : false;
    const allowOrdering = (shopDetails ? (typeof shopDetails.merchantConfig.allowOrdering !== "undefined" ? shopDetails.merchantConfig.allowOrdering : null) : false);
    const allowTableOrdering = (shopDetails ? (typeof shopDetails.merchantConfig.tableDelivery !== "undefined" ? shopDetails.merchantConfig.tableDelivery : null) : false);
    const allowBarPickupOrdering = (shopDetails ? (typeof shopDetails.merchantConfig.barPickup !== "undefined" ? shopDetails.merchantConfig.barPickup : null) : false);
    const allowTakeAwayPickupOrdering = (shopDetails ? (typeof shopDetails.merchantConfig.takeawayPickup !== "undefined" ? shopDetails.merchantConfig.takeawayPickup : null) : false);
    const allowTakeAwayDeliveryOrdering = (shopDetails ? (typeof shopDetails.merchantConfig.homeDelivery !== "undefined" ? shopDetails.merchantConfig.homeDelivery : null) : false);
    const showDownloadApp = shopDetails ? (typeof shopDetails.merchantConfig.showDownloadApp !== "undefined" ? shopDetails.merchantConfig.showDownloadApp : null) : false;

    const userType = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) : null;
    const continueAsGuest = StorageService.getItem(LOCALSTORAGE_ITEMS.CONTINUE_AS_GUEST) ? StorageService.getItem(LOCALSTORAGE_ITEMS.CONTINUE_AS_GUEST) : null;
    const productDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.PRODUCT_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.PRODUCT_DETAILS)) : null;
    const orderPlace = StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_PLACE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_PLACE) : null;
    const userTable = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE);
    const [state, setState] = useState({
        loading: false,
        product: {},
        productDetails: productDetails,
        extras: null,

        selectedExtras: [],
        selectedExtrasPrice: 0,

        selectedOption: null,
        selectedOptionInt: null,
        isSubmitBtnEnabled: true,
        productPreferences: null,
        allProductsQty: 0,
        currency: null,
        totalCartProducts: 1,
        loyaltyPoints: 0,
        category: null,
        isHelpMsgVisible: false,
        isAllergenPopupVisible: false,
        loginOrContinueAsGuestVisible: false
    });

    const [hasMultiOrdersTable, setHasMultiOrdersTable] = useState(false);

    useEffect(() => {
        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.PRODUCT_DETAILS,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.PRODUCT_DETAILS
        });
        if (StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE) && hasMultiOrders === false) {
            getTableById().then(tableResponse => {
                setHasMultiOrdersTable(tableResponse.data.multiOrders)
            });
        }
    }, []);


    const isAllowedToOrder = () => {
        if (readonly === "true") {
            return false;
        }
        if (!allowOrdering) {
            return false;
        }

        if (orderPlace === ORDER_PLACE.TABLE && !userTable) {
            return false;
        }
        if (orderPlace === ORDER_PLACE.TABLE && !allowTableOrdering) {
            return false;
        }
        if (orderPlace === ORDER_PLACE.BAR && !allowBarPickupOrdering) {
            return false;
        }

        if (orderPlace === ORDER_PLACE.TAKEAWAY && (!allowTakeAwayPickupOrdering && !allowTakeAwayDeliveryOrdering)) {
            // daca una sau ambele flaguri sunt dezactivate returnam fals, altfel returnam true si restul logicii se produce in TakeAwayOrderReview
            return false;
        }

        if (orderPlace === ORDER_PLACE.NOT_FOUND) {
            return false;
        }
        return true;
    }

    const setContinueAsGuest = () => {
        setState({
            ...state,
            loginOrContinueAsGuestVisible: false
        })
        goBackToMenuPage();
    }

    const getTableById = async () => {
        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "tid": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE)
        }
        const response = await UserService.getTableById(body);
        if (response.ok) {
            console.log("getTableById: ", response.data);
        } else {
            console.log("Error getTableById");
        }
        return response;
    }


    const goBackToMenuPage = () => {
        if (state.productDetails.isTakeAwayMenu) {
            navigateTo(PATH.TAKEAWAY);
        } else {
            navigateTo(PATH.ALL_PRODUCTS);
        }
    };

    const toggleVisibility = (e) => {

        e.preventDefault();
        setState({
            ...state,
            isHelpMsgVisible: !state.isHelpMsgVisible
        })
    }


    const toggleAllergenPopup = (e) => {

        e.preventDefault();
        setState({
            ...state,
            isAllergenPopupVisible: !state.isAllergenPopupVisible
        })
    }

    const closeHelpDialog = (e) => {
        if (e.target.className === "help-icon") {
            return;
        }

        setState({
            ...state,
            isHelpMsgVisible: false
        })
    }

    const closeAllergenPopup = (e) => {
        if (e.target.className === "help-icon") {
            return;
        }

        setState({
            ...state,
            isAllergenPopupVisible: false
        })
    }


    const increaseQuantity = () => {

        if (StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE) == null
            && state.productDetails.isTakeAwayMenu !== true
            && allowBarPickupOrdering !== true) {

            EventBus.dispatch("QRwasNotScaned");
            return;
        }
        if (!hasMultiOrdersTable && !hasMultiOrders && StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID)) {
            EventBus.dispatch("multiOrdersSetToFalse");
            return;
        }
        if (!isShopOpen()) {
            EventBus.dispatch("shopIsClosed");
            return;
        }

        setState({
            ...state,
            totalCartProducts: state.totalCartProducts + 1
        })
    };

    const decreaseQuantity = () => {
        if (!isShopOpen()) {
            EventBus.dispatch("shopIsClosed");
            return;
        }
        if (state.totalCartProducts > 1) {
            setState({
                ...state,
                totalCartProducts: state.totalCartProducts - 1
            })
        }
    };

    const handleSubmit = () => {
        if (readonly === "true") {
            navigateTo(PATH.SCAN_QR_TO_CONTINUE);
            return;
        }

         // //TODO: check if the number of selected extras < minExtras or > maxExtras     
        if(state.productDetails.product.minExtras && state.productDetails.product.minExtras > (state.selectedExtras?.length || 0)){
            console.error("Selected extras < " + state.productDetails.product.minExtras);
            EventBus.dispatch("minExtrasError", state.productDetails.product.minExtras - (state.productDetails.product.reqExtras?.length || 0));
            return;
        }

        if(state.productDetails.product.maxExtras && state.productDetails.product.maxExtras < (state.selectedExtras?.length || 0)){
            console.error("Selected extras > " + state.productDetails.product.maxExtras);
            EventBus.dispatch("maxExtrasError", state.productDetails.product.maxExtras - (state.productDetails.product.reqExtras?.length || 0));
            return;
        }

    
        //
        if ((userType === USER_TYPES.ANONYMOUS || userType === null) &&
            (continueAsGuest === null || continueAsGuest === "undefined") &&
            !state.productDetails.isTakeAwayMenu) {
            setState({
                ...state,
                loginOrContinueAsGuestVisible: true
            });
            addProductsToCart();
            return;
        }
        if (StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE) == null
            && state.productDetails.isTakeAwayMenu !== true
            && allowBarPickupOrdering !== true) {
            EventBus.dispatch("QRwasNotScaned");
            return;
        }
        if (!hasMultiOrdersTable && !hasMultiOrders && StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID)) {
            EventBus.dispatch("multiOrdersSetToFalse");
            return;
        }

        if (!isShopOpen()) {
            EventBus.dispatch("shopIsClosed");
            return;
        }

    
        addProductsToCart();
        goBackToMenuPage();
    };

    const addProductsToCart = () => {
        const price = state.productDetails.product.discount ? (roundHalfEven(state.productDetails.product.price * (100 - state.productDetails.product.discount) / 100)) + state.selectedExtrasPrice :
            state.productDetails.product.price + state.selectedExtrasPrice;

        const reqExtras = state.productDetails.product.reqExtras;
        const extras = state.selectedExtras.map(extra => {
            return {
                ...extra,
                isReqExtra: reqExtras?.includes(extra.pid)
            };
        });
        const product = {
            "name": state.productDetails.product.name,
            "name_int": state.productDetails.product.name_int || null,
            "pid": state.productDetails.product.pid,
            "sku": state.productDetails.product.sku,
            "quantity": state.totalCartProducts,
            "categories": state.productDetails.product.tags,
            "msg": state.productPreferences,
            "option": state.selectedOption,
            "option_int": state.selectedOptionInt,
            "extras": extras,
        }
        let localStorageCurentCart = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.CURRENT_CART));
        const category = state.productDetails.category;

        if (!localStorageCurentCart) {
            localStorageCurentCart = {};

            localStorageCurentCart[category] = {
                ...localStorageCurentCart.category,
                [product.name]: {
                    "pid": product.pid,
                    "sku": product.sku,
                    "name": product.name || null,
                    "name_int": product.name_int || null,
                    "quantity": product.quantity,
                    "price": product.price,
                    "categories": product.tags,
                    "choices": [{
                        "msg": product.msg,
                        "option": product.option || null,
                        "option_int": product.option_int || null,
                        "extras": product.extras,
                        "quantity": product.quantity,
                        "price": price
                    }]
                }
            }
        } else {
            let productEntry = localStorageCurentCart[category][product.name] || {};
            productEntry = {
                ...productEntry,
                "name": product.name,
                "name_int": product.name_int || null,
                "pid": product.pid,
                "sku": product.sku,
                "quantity": state.allProductsQty + product.quantity,
                "categories": product.tags
            }
            let choices = productEntry.choices || [];
            let found = false;
            choices.forEach(choice => {
                if (!found && choice.option == product.option && choice.msg == product.msg &&
                    (choice.extras === product.extras ||
                        choice.extras != null && product.extras != null &&
                        JSON.stringify(choice.extras) === JSON.stringify(product.extras))) {
                    choice.quantity += product.quantity;
                    found = true;
                    return;
                }
            });
            if (!found) {
                choices.push({
                    option: product.option,
                    option_int: product.option_int || null,
                    extras: product.extras,
                    msg: product.msg,
                    quantity: product.quantity,
                    price: price
                });
                productEntry.choices = choices;
            }

            localStorageCurentCart[category] = {
                ...localStorageCurentCart[category],
                [product.name]: productEntry
            }
        }

        StorageService.setItem(LOCALSTORAGE_ITEMS.CURRENT_CART, JSON.stringify(localStorageCurentCart));
    };

    const getAllAvailableExtraProducts = async (shopName) => {

        const getAllAvailableExtraProductsRequest = {
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "shop": shopName,
            "extras": state.productDetails.product.extras
        }
        const response = await ProductService.getAllAvailableExtraProducts(getAllAvailableExtraProductsRequest);
        if (response.ok) {
            return response.data;
        } else {
            EventBus.dispatch("genericErrorMsg");
            console.log("Error retrieving available extra products");
            return [];
        }
    };


    const allergenIconsMap = {
        "MOLLUSCS": molluscs,
        "EGGS": eggs,
        "FISH": fish,
        "SOY": soybeans,
        "MILK": milk,
        "PEANUTS": peanuts,
        "GLUTEN": cereals,
        "CRUSTACEANS": crustaceans,
        "MUSTARD": mustard,
        "NUTS": nuts,
        "SESAME": sesame,
        "CELERY": celery,
        "SULPHITES": sulphurdioxide,
        "LUPIN": lupin
    }

    const changePreferences = event => {
        setState({
            ...state,
            productPreferences: event.target.value
        })
    };

    const isSubmitButtonEnabled = () => {
        if(state.productDetails.product?.options?.length > 0 && state.selectedOption === null)
            return false;
        
        return state.isSubmitBtnEnabled
    }

    const changeSelectedOption = (event) => {
        setState({
            ...state,
            selectedOption: event.target.value,
            selectedOptionInt: event.target.getAttribute('data-value-int')
        })
    };


    const changeSelectedExtra = (event) => {
        const extraName = event.target.value;
        const extraNameInt = event.target.getAttribute("data-value-int");
        const extraPrice = parseInt(event.target.getAttribute("data-price"));
        const extraPid = event.target.getAttribute("data-pid");


        const foundIndex = state.selectedExtras.findIndex(e => e.name === extraName);

        let finalSelections;
        let finalSelectionsPrice;

        if (foundIndex >= 0) {
            finalSelections = state.selectedExtras.slice(0, foundIndex).concat(state.selectedExtras.slice(foundIndex + 1));
            finalSelectionsPrice = state.selectedExtrasPrice - extraPrice;
        } else {
            finalSelections = state.selectedExtras.concat([{
                name: extraName,
                name_int: extraNameInt,
                price: extraPrice,
                pid: extraPid
            }]);

            finalSelections = state.extras.filter(e => finalSelections.findIndex(ee => ee.name === e.name) >= 0);
            finalSelectionsPrice = state.selectedExtrasPrice + extraPrice
        }

        //  //TODO: check if the number of selected extras < minExtras or > maxExtras        
        // if(state.productDetails.product.minExtras && state.productDetails.product.minExtras > finalSelections?.length){
        //     console.error("Selected extras < " + state.productDetails.product.minExtras);
        //     return;
        // }

        // if(state.productDetails.product.maxExtras && state.productDetails.product.maxExtras < finalSelections?.length){
        //     console.error("Selected extras > " + state.productDetails.product.maxExtras);
        //     return;
        // }
        
        setState({
            ...state,
            selectedExtras: finalSelections,
            selectedExtrasPrice: finalSelectionsPrice,
        })
    };

    useEffect(() => {
        if (!StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME)) {
            goBackToMenuPage();
        }


        let newState = {...state};
        const shopDetails = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS));
        let pid = null;
        if (state.productDetails) {
            pid = state.productDetails.product.pid;
            newState.product = state.productDetails.product;
            newState.allProductsQty = state.productDetails.quantity;
            newState.currency = shopDetails.currency;
            // if (state.productDetails.product.options) {
            //     newState.selectedOption = newState.selectedOption || newState.product.options[0];
            //     newState.selectedOptionInt = newState.selectedOptionInt || newState.product.options_int[0];
            // }
            newState.category = state.productDetails.category;
        } else {
            if (StorageService.getItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON) === "false" && StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE)) {
                navigateTo(PATH.ALL_PRODUCTS);
            } else {
                navigateTo(-1);
            }
            return;
        }

        const loyaltyProductsPoints = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.LOYALTY_PRODUCTS_POINTS));
        if (loyaltyProductsPoints && loyaltyProductsPoints[pid]) {
            newState.loyaltyPoints = loyaltyProductsPoints[pid];
            newState.currency = shopDetails.currency;
        }

        if (newState.product.extras) {
            getAllAvailableExtraProducts(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME)).then(allExtras => {
                newState.extras = allExtras.filter(e =>
                    (typeof e.available === "undefined" || e.available) &&
                    ((typeof e.stock === "undefined") || (typeof e.hasStock === "undefined") || !e.hasStock || (e.hasStock && e.stock > 0)));

                newState.selectedExtras = allExtras.filter(e => {
                    if ((typeof e.available === "undefined" || e.available) &&
                        ((typeof e.stock === "undefined") || (typeof e.hasStock === "undefined") || !e.hasStock || (e.hasStock && e.stock > 0))) {
                        if (newState.product.reqExtras?.indexOf(e.pid) >= 0) {
                            newState.selectedExtrasPrice += e.price
                            return true;
                        } else {
                            return false;
                        }
                    } else
                        return false;
                });
                setState(newState);
            })
        } else {
            setState(newState);
        }
    }, []);

    const isRequiredExtra = (extra) => {

        if (state.product.reqExtras?.indexOf(extra) >= 0) {
            return true;
        } else {
            return false;
        }
    }


    if (state?.productDetails?.product) {
        return (
            <React.Fragment>
                {state.loginOrContinueAsGuestVisible ?

                    <LoginOrContinueAsGuest
                        setContinueAsGuest={setContinueAsGuest}
                        redirectUrlAfterLogin={state.productDetails.isTakeAwayMenu ? PATH.TAKEAWAY : PATH.ALL_PRODUCTS}/>
                    :
                    <>
                        <Header
                            headerSize={HEADER_SIZE.BIG}
                            hasBackgroundImg={true}
                            imgUrl={state.productDetails.product.pic || noPhotoImg}
                            isProductPage={true}
                            hasBackBtn={true}
                            hasModal={true}
                            discount={state.productDetails.product.discount}
                        />
                        <>
                            <div data-qa="product-details" className="product-details">
                                {state.loyaltyPoints > 0 ?
                                    (showDownloadApp === true || showDownloadApp === null) &&
                                    <div className="loyalty-points-msg" data-qa="product-details-loyalty-points-msg">
                                        <div className="row">
                                            <img src={loyaltyRibbon} className="loyalty-ribbon"/>
                                            {state.loyaltyPoints === 1 ?
                                                <FormattedMessage id="YouCanGetLoyaltyPointfromThisProduct"
                                                                  values={{param: state.loyaltyPoints}}/>
                                                :
                                                <FormattedMessage id="YouCanGetLoyaltyPointsfromThisProduct"
                                                                  values={{param: state.loyaltyPoints}}/>
                                            }
                                        </div>
                                    </div>
                                    : null
                                }
                                <div className="row product-name-and-price">
                                    <h2 className="name"
                                        data-qa="product-details-name">{getProdName(state.productDetails.product)}</h2>
                                    {state.currency && <div className="price">
                                        {state.productDetails.product.discount ?
                                            <>
                                                <h2 data-qa="product-details-product-price"
                                                    className="price-without-discount">
                                                    <IntlProvider
                                                        locale={getAppLocale()}>
                                                        <FormattedNumber
                                                            value={state.productDetails.product.finalPriceWithReqExtras / 100.0
                                                            }
                                                            style="currency"
                                                            minimumFractionDigits={2}
                                                            maximumFractionDigits={2}
                                                            currency={state.currency}/>
                                                    </IntlProvider>
                                                </h2>
                                                <h2 data-qa="product-details-product-price"
                                                    className="price-with-discount"><IntlProvider
                                                    locale={getAppLocale()}>
                                                    <FormattedNumber
                                                        value={roundHalfEven(state.productDetails.product.price * (100 - state.productDetails.product.discount) / 100) / 100.0 + state.productDetails.product.reqExtrasPrice / 100.0}
                                                        style="currency"
                                                        minimumFractionDigits={2}
                                                        maximumFractionDigits={2}
                                                        currency={state.currency}/>
                                                </IntlProvider></h2>
                                            </>
                                            :
                                            <h2 data-qa="product-details-product-price"><IntlProvider
                                                locale={getAppLocale()}>
                                                <FormattedNumber
                                                    value={state.productDetails.product.finalPriceWithReqExtras / 100.0}
                                                    style="currency"
                                                    minimumFractionDigits={2}
                                                    maximumFractionDigits={2}
                                                    currency={state.currency}/>
                                            </IntlProvider></h2>
                                        }
                                    </div>
                                    }
                                </div>
                                {state.productDetails.product.desc ?
                                    <div className="row product-description">
                                        {/*<p>{getProdDesc(state.product)}</p>*/}
                                        <p dangerouslySetInnerHTML={{__html: getProdDesc(state.productDetails.product)}}></p>
                                    </div>
                                    : null
                                }
                                 {/* TREAT REQUIRED EXTRAS */}
                                {state.extras?.length > 0 &&  state.extras.some(extra => isRequiredExtra(extra.pid)) &&

                                    <div
                                        className={(isAllowedToOrder()) ? "extras" : "extras order-not-allowed"}
                                        data-qa="product-details-extras">
                                        <p className="input-subtitle">
                                            <FormattedMessage id="Includes"/>
                                        </p>
                                        {state.extras?.map((extra, index) =>
                                            <>
                                                {isRequiredExtra(extra.pid) &&
                                                    <label key={extra + index} className="checkbox" htmlFor="extra">

                                                        {isRequiredExtra(extra.pid) && getExtraProductName(extra)}
                                                        {<input
                                                            className="disabled"
                                                            data-qa="product-details-extra-checkbox"
                                                            type="checkbox"
                                                            value={extra.name}
                                                            data-value-int={extra.name_int}
                                                            data-pid={extra.pid}
                                                            defaultChecked={true}
                                                            disabled={true}
                                                            data-price={extra.price}
                                                            name="extra"
                                                        /> }&nbsp;<i>(
                                                        <FormattedMessage id="Mandatory"/>
                                                        {extra.returnable &&
                                                            <>
                                                                ,&nbsp;
                                                                <FormattedMessage id="Returnable"/>
                                                            </>
                                                        }
                                                        )
                                                    </i>
                                                        <span className="checksquare"></span>
                                                        <p data-qa="product-details-extra-price" className="price">
                                                            <IntlProvider
                                                                locale={getAppLocale()}>
                                                                <FormattedNumber
                                                                    value={extra.price / 100.0
                                                                    }
                                                                    style="currency"
                                                                    minimumFractionDigits={2}
                                                                    maximumFractionDigits={2}
                                                                    currency={state.currency}/>
                                                            </IntlProvider>
                                                        </p>


                                                    </label>
                                                }
                                            </>

                                        )}
                                    </div>
                                }

                                {state.productDetails.product.allergens && state.productDetails.product.allergens?.length > 0 ?

                                    <div data-qa="product-details-allergens" className="allergens">
                                        {state.isAllergenPopupVisible &&
                                            <div className="close-help-msg-overlay"
                                                 onClick={e => closeAllergenPopup(e)}></div>}
                                        <div
                                            className={state.isAllergenPopupVisible ? "visible info-message" : "info-message hidden"}>
                                            <p className="row input-subtitle"><span className="row"><FormattedMessage
                                                id="Legend"/></span></p>
                                            <p className="row"><img alt="allergen" src={cereals}/> <FormattedMessage
                                                id="CerealsContainingGluten"/></p>
                                            <p className="row"><img alt="allergen" src={crustaceans}/> <FormattedMessage
                                                id="Crustaceans"/></p>
                                            <p className="row"><img alt="allergen" src={eggs}/> <FormattedMessage
                                                id="Eggs"/></p>
                                            <p className="row"><img alt="allergen" src={fish}/> <FormattedMessage
                                                id="Fish"/></p>
                                            <p className="row"><img alt="allergen" src={peanuts}/> <FormattedMessage
                                                id="Peanuts"/></p>
                                            <p className="row"><img alt="allergen" src={soybeans}/> <FormattedMessage
                                                id="Soybeans"/></p>
                                            <p className="row"><img alt="allergen" src={milk}/> <FormattedMessage
                                                id="Milk"/></p>
                                            <p className="row"><img alt="allergen" src={nuts}/> <FormattedMessage
                                                id="Nuts"/></p>
                                            <p className="row"><img alt="allergen" src={celery}/> <FormattedMessage
                                                id="Celery"/></p>
                                            <p className="row"><img alt="allergen" src={mustard}/> <FormattedMessage
                                                id="Mustard"/></p>
                                            <p className="row"><img alt="allergen" src={sesame}/> <FormattedMessage
                                                id="Sesame"/></p>
                                            <p className="row"><img alt="allergen" src={sulphurdioxide}/>
                                                <FormattedMessage id="SulphurDioxideAndSulphites"/></p>
                                            <p className="row"><img alt="allergen" src={lupin}/> <FormattedMessage
                                                id="Lupin"/></p>
                                            <p className="row"><img alt="allergen" src={molluscs}/> <FormattedMessage
                                                id="Molluscs"/></p>

                                            <p className="row close-row"><a onClick={e => closeAllergenPopup(e)}
                                                                            className="link"><FormattedMessage
                                                id="Close"/></a></p>
                                        </div>
                                        <div className="row">
                                            <p className="input-subtitle">
                                                <FormattedMessage id="Allergens"/>
                                            </p>
                                            <div onClick={e => toggleAllergenPopup(e)} className="help-icon">
                                                ?
                                            </div>
                                        </div>
                                        {state.productDetails.product.allergens?.map((allergen, index) => <img
                                            key={index} className="allergen"
                                            src={allergenIconsMap[allergen]}/>)}
                                    </div>
                                    : null
                                }


                                {state.productDetails.product?.options?.length > 0 && <div
                                    className={isAllowedToOrder() ? "mandatory-options" : "mandatory-options order-not-allowed"}
                                    data-qa="product-details-mandatory-options">
                                    <p className="input-subtitle">
                                        {isAllowedToOrder()  ?
                                            <FormattedMessage id="SelectOneOption"/>
                                            :
                                            <FormattedMessage id="Options"/>
                                        }
                                    </p>
                                    {state.productDetails.product.options?.map((mandatoryOption, index) =>
                                        <label key={mandatoryOption + index} className="radio"
                                               htmlFor="mandatory-option">
                                            {getProdOptions(state.productDetails.product, index)}
                                            <input
                                                data-qa="product-details-option-radio"
                                                type="radio"
                                                value={mandatoryOption}
                                                data-value-int={state.productDetails.product.options_int[index]}
                                                onChange={changeSelectedOption}
                                                name="mandatory-option"
                                                defaultChecked={false}
                                            />
                                            <span className="checkround"></span>
                                        </label>
                                    )}
                                </div>
                                }


                                {isAllowedToOrder()  &&
                                    <div className="preferences" data-qa="product-details-preferences">
                                        <p className="input-subtitle">
                                            <FormattedMessage id="AddPreferences"/>
                                        </p>
                                        <div className="preferences-form">
                                            <div onClick={e => toggleVisibility(e)} className="help-icon">
                                                ?
                                            </div>

                                            {state.isHelpMsgVisible &&
                                                <div className="close-help-msg-overlay"
                                                     onClick={e => closeHelpDialog(e)}></div>}
                                            <div
                                                className={state.isHelpMsgVisible ? "visible info-message" : "info-message hidden"}>
                                                <p><FormattedMessage id="PreferencesHintMsg"/></p>
                                            </div>
                                            <FormattedMessage id="Preferences" defaultMessage="search">
                                                {placeholder =>
                                                    <input
                                                        type="text"
                                                        data-qa="product-details-preferences-input"
                                                        onChange={changePreferences}
                                                        maxLength={150}
                                                        placeholder={placeholder}
                                                        autoComplete="off"
                                                        name="Preferences"/>
                                                }
                                            </FormattedMessage>
                                        </div>
                                    </div>
                                }
                                {/* TREAT NOT REQUIRED EXTRAS */}                                                        
                                {state.extras?.length > 0 &&
                                    <div
                                        className={isAllowedToOrder() ? "extras" : "extras order-not-allowed"}
                                        data-qa="product-details-extras">
                                        <p className="input-subtitle">
                                            {isAllowedToOrder()  ?
                                                <>                                                
                                                <FormattedMessage id="ChooseExtras"/>
                                                <span style={{"color": "#696c81", "font-size": "14px"}}>{(state.productDetails.product.minExtras - (state.productDetails.product.reqExtras?.length || 0)) > 0 ?
                                                    " min " + (state.productDetails.product.minExtras - (state.productDetails.product.reqExtras?.length || 0))
                                                    : ""
                                                }
                                                {(state.productDetails.product.maxExtras - (state.productDetails.product.reqExtras?.length || 0)) > 0 ?
                                                    " max " + (state.productDetails.product.maxExtras - (state.productDetails.product.reqExtras?.length || 0))
                                                    : ""
                                                }
                                                </span>
                                                </>
                                                :
                                                <FormattedMessage id="AvailableExtras"/>
                                            }
                                        </p>
                                        {state.extras?.map((extra, index) =>
                                            <>
                                                {!isRequiredExtra(extra.pid) && <label key={extra + index} className="checkbox" htmlFor="extra">

                                                    {getExtraProductName(extra)}
                                                    <input
                                                        data-qa="product-details-extra-checkbox"
                                                        type="checkbox"
                                                        value={extra.name}
                                                        data-value-int={extra.name_int}
                                                        data-pid={extra.pid}
                                                        defaultChecked={false}
                                                        disabled={false}
                                                        data-price={extra.price}
                                                        onChange={changeSelectedExtra}
                                                        name="extra"
                                                    />


                                                    <span className="checksquare"></span>
                                                    <p data-qa="product-details-extra-price" className="price">
                                                        <IntlProvider
                                                            locale={getAppLocale()}>
                                                            <FormattedNumber
                                                                signDisplay="exceptZero"
                                                                value={extra.price / 100.0
                                                                }
                                                                style="currency"
                                                                minimumFractionDigits={2}
                                                                maximumFractionDigits={2}
                                                                currency={state.currency}/>
                                                        </IntlProvider>
                                                    </p>
                                                </label>}
                                            </>
                                        )}
                                    </div>
                                }


                            </div>
                        </>
                        {isAllowedToOrder()  && <ProductDetailsActionsBar
                            isVisible={state.totalCartProducts !== 0}
                            buttonName={<FormattedMessage id="AddToOrder"/>}
                            dataQAIdentifier={"product-details-submit-btn"}
                            btnClassName={isSubmitButtonEnabled() ? "btn btn-default btn-xl" : "btn btn-default btn-xl btn-disabled"}
                            buttonAction={() => {
                                if(isSubmitButtonEnabled())
                                    handleSubmit();
                            }}
                            extraHtml={
                                <QuantityModifier
                                    onlyLoggedUser={state.productDetails.onlyLoggedUser}
                                    quantity={state.totalCartProducts}
                                    increaseQuantity={increaseQuantity}
                                    decreaseQuantity={decreaseQuantity}
                                    bigSize={true}
                                />
                            }

                        ></ProductDetailsActionsBar>}

                        {state.loading ?
                            <div className="spinner" data-qa="spinner"><Spinner/></div>
                            : null
                        }
                    </>
                }
            </React.Fragment>
        )
    } else {
        return (
            <ScanQrToContinue/>
        )
    }

}

export default ProductDetails;
